(function () {
  const mapEl = document.getElementById("CoolpackCoverMap");
  if (!mapEl) return;

  let coverMap = {};
  try {
    coverMap = JSON.parse(mapEl.textContent || "{}");
  } catch (e) {
    console.warn("Coolpack cover map JSON parse failed", e);
    return;
  }

  const checkbox = document.getElementById("AddCoverCheckbox");
  const priceText = document.getElementById("AddCoverPriceText");
  const helpText = document.getElementById("AddCoverHelp");
  if (!checkbox) return;

  const productForms = Array.from(document.querySelectorAll('form[action*="/cart/add"]'));
  if (!productForms.length) return;

  function formatMoneyFromCents(cents) {
    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  function getVariantIdInput(form) {
    return form.querySelector('[name="id"]');
  }

  function getQty(form) {
    const qtyInput =
      form.querySelector('[name="quantity"]') ||
      form.querySelector('input.quantity__input') ||
      form.querySelector('input[type="number"]');
    const qty = qtyInput ? Number(qtyInput.value || 1) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getATCButton(form) {
    return (
      form.querySelector('button[type="submit"]') ||
      form.querySelector('button[name="add"]') ||
      form.querySelector("[data-add-to-cart] button") ||
      form.querySelector("[data-add-to-cart]")
    );
  }

  // ---- Button label handling (DO NOT clobber Broadcast markup) ----
  function getPriceSpan(btn) {
  return btn.querySelector(".btn__price[data-product-price]");
}

function updateATCForForm(form) {
  const idInput = getVariantIdInput(form);
  const btn = getATCButton(form);
  if (!idInput || !btn) return;

  const priceSpan = getPriceSpan(btn);
  if (!priceSpan) return;

  const variantId = String(idInput.value || "");
  const entry = coverMap[variantId];
  if (!entry) return;

  const base = Number(entry.pack_price_cents || 0);
  const cover =
    checkbox.checked && entry.cover_variant_id && entry.cover_available
      ? Number(entry.cover_price_cents || 0)
      : 0;

  const total = base + cover;

  // Store original base price once so we can restore it
  if (!priceSpan.dataset.basePrice) {
    priceSpan.dataset.basePrice = priceSpan.textContent.trim();
  }

  priceSpan.textContent = formatMoneyFromCents(total);
}

function updateATCAllForms() {
  productForms.forEach(updateATCForForm);
}

  // ---- Cover option UI ----
  function syncCoverUI() {
  let activeEntry = null;

  // Find the currently selected variant from any of the ATC forms
  for (const form of productForms) {
    const idInput = getVariantIdInput(form);
    if (!idInput) continue;

    const variantId = String(idInput.value || "");
    if (coverMap[variantId]) {
      activeEntry = coverMap[variantId];
      break;
    }
  }

  // Helper: restore base price on all ATC buttons
  function restoreBasePrices() {
    productForms.forEach((form) => {
      const btn = getATCButton(form);
      if (!btn) return;

      const priceSpan = btn.querySelector(".btn__price[data-product-price]");
      if (!priceSpan) return;

      if (priceSpan.dataset.basePrice) {
        priceSpan.textContent = priceSpan.dataset.basePrice;
      }
    });
  }

  // If no cover mapping exists for this variant
  if (!activeEntry || !activeEntry.cover_variant_id) {
    checkbox.checked = false;
    checkbox.disabled = true;

    if (priceText) priceText.textContent = "";
    if (helpText) helpText.textContent = "Cover not available for this size.";

    restoreBasePrices();
    return;
  }

  // Show cover price next to checkbox
  if (priceText) {
    priceText.textContent = `(+${formatMoneyFromCents(activeEntry.cover_price_cents)})`;
  }

  // If cover is mapped but unavailable (OOS)
  if (!activeEntry.cover_available) {
    checkbox.checked = false;
    checkbox.disabled = true;

    if (helpText) helpText.textContent = "Cover currently out of stock for this size.";

    restoreBasePrices();
    return;
  }

  // Cover is available and mapped
  checkbox.disabled = false;
  if (helpText) {
    helpText.textContent =
      "We’ll automatically match the cover size to your selected pack.";
  }

  // Update ATC price normally (combined if checked, base if not)
  updateATCAllForms();
}

  async function addItem(variantId, quantity, properties) {
    const payload = { id: Number(variantId), quantity: Number(quantity || 1) };
    if (properties && Object.keys(properties).length) payload.properties = properties;

    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) throw new Error(await res.text());
    return res.json();
  }

  async function refreshCartUIHard() {
    try {
      await fetch("/cart.js", { headers: { Accept: "application/json" } });
    } catch (e) {}

    [
      "cart:refresh",
      "cart:updated",
      "theme:cart:refresh",
      "theme:cart:updated",
      "cart:build",
      "cart:render",
      "drawer:open",
      "cartdrawer:open",
    ].forEach((name) => document.dispatchEvent(new CustomEvent(name)));

    // If drawer still doesn't refresh reliably, uncomment:
    // window.location.href = "/cart";
  }

  // Initial sync
  syncCoverUI();

  // Keep UI updated
  productForms.forEach((form) => {
    form.addEventListener("change", () => requestAnimationFrame(syncCoverUI));
  });
  document.addEventListener("variant:change", syncCoverUI);
  document.addEventListener("variant:changed", syncCoverUI);

 checkbox.addEventListener("change", () => {
  updateATCAllForms();
});

  // Intercept submit on BOTH forms in capture phase
  productForms.forEach((form) => {
    form.addEventListener(
      "submit",
      async function (e) {
        if (!checkbox.checked) return;

        const idInput = getVariantIdInput(form);
        if (!idInput) return;

        const variantId = String(idInput.value || "");
        const entry = coverMap[variantId];
        if (!entry) return; // not our product form

        if (!entry.cover_variant_id || !entry.cover_available) {
          checkbox.checked = false;
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        const qty = getQty(form);
        const atcBtn = getATCButton(form);

        const packProps = { _add_cover: "yes", _cover_sku: entry.cover_sku || "" };
        const coverProps = { _is_cover_for: entry.pack_sku || "", _pack_variant_id: variantId };

        try {
          if (atcBtn) atcBtn.setAttribute("aria-busy", "true");

          await addItem(variantId, qty, packProps);
          await addItem(entry.cover_variant_id, qty, coverProps);

          await refreshCartUIHard();
        } catch (err) {
          console.error(err);
          alert("We added the pack, but the matching cover couldn’t be added (it may be out of stock).");
          await refreshCartUIHard();
        } finally {
          if (atcBtn) atcBtn.removeAttribute("aria-busy");
          updateATCAllForms();
        }
      },
      true
    );
  });
})();